import { createSlice } from "@reduxjs/toolkit";
import { getExperienceDone } from "../thunks/experience/getExperienceDone";
import { getExperienceInvitation } from "../thunks/experience/getExperienceInvitation";
import { getExperienceRegistration } from "../thunks/experience/getExperienceRegistration";
import { getExperiencePayment } from "../thunks/experience/getExperiencePayment";

const initialState = {
  doneExperiences: [],
  experienceInvitations: [],
  experienceRegistrations: [],
  confirmationExperiences: [],
  loading: false,
  error: null,
};
const experienceSlice = createSlice({
  name: "experiences",
  initialState,
  reducers: {
    
  },
  extraReducers: (builder) => {
    builder
      .addCase(getExperienceDone.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getExperienceDone.fulfilled, (state, action) => {
        state.doneExperiences = [...action.payload];
        state.loading = false;
      })
      .addCase(getExperienceDone.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to load experiments.";
      })

      .addCase(getExperienceInvitation.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getExperienceInvitation.fulfilled, (state, action) => {
        state.experienceInvitations = [...action.payload];
        state.loading = false;
      })
      .addCase(getExperienceInvitation.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to load experiments.";
      })

      .addCase(getExperienceRegistration.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getExperienceRegistration.fulfilled, (state, action) => {
        state.experienceRegistrations = [...action.payload];
        state.loading = false;
      })
      .addCase(getExperienceRegistration.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to load experiments.";
      })

      .addCase(getExperiencePayment.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getExperiencePayment.fulfilled, (state, action) => {
        state.confirmationExperiences = [...action.payload];
        state.loading = false;
      })
      .addCase(getExperiencePayment.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to load experiments.";
      });
  },
});

export default experienceSlice.reducer;
